import React, { AnchorHTMLAttributes } from 'react';
import './AnchorText.scss';

export type AnchorTextProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href?: string;
};

export function AnchorText({ children, ...rest }: React.PropsWithChildren<AnchorTextProps>) {
  return (
    <a {...rest} className="anchor-text">
      {children}
    </a>
  );
}
